// src/components/Inbox/ConversationsListTabs.js
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  Tabs,
  Tab,
  Popover,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
} from '@material-ui/core'
import { filterConversationsList } from 'actions/inbox'
import { create } from 'actions/data'
import { DATA_API_URL } from 'utils/AllURLs'
import { listInbox, setCursor } from 'actions/inbox'
// import Button from 'components/theme/Button'
// import DudeReadingV2Icon from 'components/theme/DudeReadingV2Icon'

const styles = theme => ({
  tabsRoot: {},
  tabRoot: {
    minWidth: 0,
    [theme.breakpoints.up('md')]: {
      minWidth: 0,
    },
  },
  labelContainer: {
    padding: 6,
    [theme.breakpoints.up('md')]: {
      padding: 6,
    },
  },
  popoverContent: {
    padding: '16px',
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  boldLabel: {
    fontWeight: 'bold',
    color: 'rgba(0, 0, 0, 0.65)',
  },
  description: {
    marginLeft: '2px',
    marginBottom: '8px',
    fontSize: '0.9rem',
    color: 'rgba(0, 0, 0, 0.54)', // Default secondary text color
  },
  formControlLabel: {
    alignItems: 'flex-start',
    marginBottom: '16px',
  },
  legendLabel: {
    fontWeight: 'bold',
    marginBottom: '8px',
  },
})

const tabMap = {
  'recent/all': 2,
  'recent/in': 2,
  'recent/out': 2,
  'recent/out_r': 2,
  'recent/followup': 1,
  unanswered: 1,
  inbound: 2,
  all: 0,
  2: 'recent/all',
  1: 'recent/followup',
  0: 'all',
}

const ConversationsListTabs = ({
  classes,
  conversationsListFilter,
  filterConversationsList,
  create,
  listInbox,
  loading,
  username,
  vr_account_id,
  setCursor,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const tabClasses = {
    root: classes.tabRoot,
    labelContainer: classes.labelContainer,
  }

  const handlePreferenceChange = preference => {
    filterConversationsList(preference)
    create({
      entityType: 'inboxfilter',
      entity: {
        id: `inboxfilter-${username}-${vr_account_id}`,
        preference,
      },
      url: `${DATA_API_URL}/inboxfilter`,
      hasSchema: false,
      snackbarMessage: 'none',
    }) /* .then(() => { 
              setCursor('')
            }) */
      .then(() => {
        listInbox({ endpoint: preference })
      })
  }

  const handleRecentChange = preference => {
    setAnchorEl(null)
    handlePreferenceChange(preference)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const arrowMap = {
    'recent/all': '↕',
    'recent/in': '↓',
    'recent/out': '↑',
    'recent/out_r': '⇅',
  }

  return (
    <>
      <Tabs
        textColor="primary"
        classes={{ root: classes.tabsRoot }}
        value={
          open
            ? 2
            : typeof tabMap[conversationsListFilter] !== 'undefined'
            ? tabMap[conversationsListFilter]
            : 0
        }
        onChange={(e, newValue) => {
          if (!loading && newValue !== 2) {
            const preference = tabMap[newValue]
            handlePreferenceChange(preference)
          }
        }}
        variant="fullWidth"
      >
        <Tab classes={tabClasses} label="All" disabled={loading} />
        <Tab classes={tabClasses} label="Follow up" disabled={loading} />
        <Tab
          classes={tabClasses}
          label={`Recent ${arrowMap[conversationsListFilter] || ''}`}
          onClick={e => setAnchorEl(e.currentTarget)}
          aria-describedby={id}
          disabled={loading}
        />
      </Tabs>
      <Popover
        id={id}
        classes={{ paper: classes.popoverContent }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={() => setAnchorEl(null)}
      >
        <FormControl component="fieldset" className={classes.radioGroup}>
          <FormLabel component="legend" className={classes.legendLabel}>
            Select an option:
          </FormLabel>
          <RadioGroup
            aria-label="recent"
            name="recent"
            onChange={e => handleRecentChange(e.target.value)}
          >
            <FormControlLabel
              value="recent/all"
              control={<Radio />}
              label={
                <div className={classes.labelContainer}>
                  <span className={classes.boldLabel}>All ↕</span>
                  <div className={classes.description}>
                    All recent interactions, both inbound and outbound.
                  </div>
                </div>
              }
              disabled={loading}
              classes={{ root: classes.formControlLabel }}
            />
            <FormControlLabel
              value="recent/in"
              control={<Radio />}
              label={
                <div className={classes.labelContainer}>
                  <span className={classes.boldLabel}>In ↓</span>
                  <div className={classes.description}>
                    The latest messages received from leads.
                  </div>
                </div>
              }
              disabled={loading}
              classes={{ root: classes.formControlLabel }}
            />
            <FormControlLabel
              value="recent/out"
              control={<Radio />}
              label={
                <div className={classes.labelContainer}>
                  <span className={classes.boldLabel}>Out ↑</span>
                  <div className={classes.description}>
                    Your most recent sent messages awaiting responses.
                  </div>
                </div>
              }
              disabled={loading}
              classes={{ root: classes.formControlLabel }}
            />
            <FormControlLabel
              value="recent/out_r"
              control={<Radio />}
              label={
                <div className={classes.labelContainer}>
                  <span className={classes.boldLabel}>Sent ⇅</span>
                  <div className={classes.description}>
                    Your latest messages sent to each lead.
                  </div>
                </div>
              }
              disabled={loading}
              classes={{ root: classes.formControlLabel }}
            />
          </RadioGroup>
        </FormControl>
      </Popover>
    </>
  )
}

export default connect(
  state => ({
    conversationsListFilter: state.inbox.conversationsListFilter,
    loading:
      state.inbox.conversationsListCursor[state.inbox.conversationsListFilter]
        ?.loading,
    username: state.auth.session?.idToken?.payload?.['cognito:username'],
    vr_account_id:
      state.auth?.session?.idToken?.payload?.['custom:vr_account_id'],
  }),
  dispatch =>
    bindActionCreators(
      { filterConversationsList, create, listInbox, setCursor },
      dispatch,
    ),
)(withStyles(styles)(ConversationsListTabs))
